module.exports = __webpack_public_path__ + "img/background-login.02414785.png";